import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { ref, watch } from "@vue/reactivity";

export default function (element, dataset) {
  const currentTab = ref(1);
  const items = element.querySelectorAll('[data-element="item"]');
  const images = element.querySelectorAll('[data-element="image"]');

  if (window.innerWidth > 991) {
    moveImages(element);
  }

  items.forEach((e, index) => {
    e.addEventListener("click", () => {
      currentTab.value = index;
    });
  });

  watch(currentTab, (newValue, oldValue) => {
    let itemsToClose = Array.from(items).filter((item, index) => {
      return index !== newValue;
    });

    let imagesToHide = Array.from(images).filter((image, index) => {
      return index !== newValue;
    });

    let tl = gsap.timeline();

    tl.to(itemsToClose, {
      height: "2.1rem",
    });

    tl.to(
      items[newValue],
      {
        height: "auto",
      },
      "<",
    );

    tl.to(
      imagesToHide,
      {
        opacity: 0,
      },
      "<",
    );

    tl.to(
      images[newValue],
      {
        opacity: 1,
      },
      "<",
    );
    itemsToClose.forEach((e) => {
      e.querySelector(".g_large_dot").classList.remove("is-open");
      gsap.to(e.querySelector(".at_item_tab"), {
        backgroundColor: "#f1f1f1",
      });
    });

    items[newValue].querySelector(".g_large_dot").classList.add("is-open");
    gsap.to(items[newValue].querySelector(".at_item_tab"), {
      backgroundColor: "#fef7aa",
    });
  });

  currentTab.value = 0;
}

function moveImages(element) {
  const images = element.querySelectorAll('[data-element="image"]');
  const holder = element.querySelector('[data-element="image-holder"]');

  images.forEach((e) => {
    holder.append(e);
  });
}
